/**
 * @file   : SimplePageHero.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 10:02:51 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import TextHoverable, {
  BACKGROUND_COLOR,
} from '../../../external/components/link/TextHoverable'
import HTag from '../../../external/components/text/HTag'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import SimpleHero from './SimpleHero'

const SimplePageHero = ({ imageURL, titleText, taglineText }) => {
  let titleUI = null
  let taglineUI = null

  if (!isEmpty(titleText)) {
    titleUI = (
      <Cont>
        <HTag h1>
          <TextHoverable
            asSpan
            fontSizeType={2}
            fontFamily={'Georgia'}
            fontColor={'white'}
            backgroundColor={BACKGROUND_COLOR.BLUE80}
            selected
          >
            {titleText}
          </TextHoverable>
        </HTag>
      </Cont>
    )
  }

  if (!isEmpty(taglineText)) {
    taglineUI = (
      <Cont>
        <TextHoverable
          asSpan
          fontSizeType={4}
          fontFamily={'Georgia'}
          fontColor={'white'}
          backgroundColor={BACKGROUND_COLOR.BLUE80}
          selected
        >
          {taglineText}
        </TextHoverable>
      </Cont>
    )
  }

  const titleAndTag = (
    <Cont>
      {titleUI}
      {taglineUI}
    </Cont>
  )

  return (
    <SimpleHero
      headerContent={titleAndTag}
      imageURL={isEmpty(imageURL) ? null : imageURL}
    />
  )
}

SimplePageHero.propTypes = {
  imageURL: PropTypes.string,
  titleText: PropTypes.string,
  taglineText: PropTypes.string,
}

export default SimplePageHero
